<script>

import('@/node_modules/vuetify/dist/vuetify.min.css')

export default {
    name: 'dkbr',
    created() {
        try{
            this.ST._load()
            this.CS.res(
                `Settings are loaded`, this.CLASS, 'created')
        }
        catch(err) {
            this.CS.err(
                `Can't load settings`, this.CLASS, 'created', err)
        }
    },
    beforeDestroy() {
        try{
            this.ST._save()
            this.CS.res(
                `Settings are saved`, this.CLASS, 'beforeDestroy')
        }
        catch(err) {
            this.CS.err(
                `Can't save settings`, this.CLASS, 'beforeDestroy', err)
        }
    },
}
</script>

<template lang="pug">

v-app#app.dkbr
    router-view
</template>

<style lang="sass">

@import './sass/root.sass'
@import '~vue-material/dist/vue-material.min.css'
@import '~vue-material/dist/theme/engine'

#app.dkbr
    overflow: scroll
    min-width: $width-min
    max-width: $width-max
    width: 100%
    margin: 0 auto

$color-light:  rgb(255, 255, 255)          // white
$color-light1: rgb(201, 201, 201)          // gray
$color-light2: rgb(186, 0, 0)              // red
$color-light3: rgb(107, 126, 81)           // almost green
$color-dark:   rgb(0, 0, 0)                // black
$color-dark1:  rgb(0, 105, 152)            // light blue
$color-dark2:  rgb(0, 69, 102)             // medium blue
$color-dark3:  rgb(0, 58, 86)              // dark blue

$c1: $color-dark3
$c2: $color-light3
@include md-register-theme('default', (primary: $c1, accent: $c2, theme: dark))
$c1: $color-dark3
$c2: $color-light3
@include md-register-theme('th1',  (primary: $c1, accent: $c2, theme: dark))
@include md-register-theme('th1i', (primary: $c2, accent: $c1, theme: light))
$c1: $color-dark2
$c2: $color-light3
@include md-register-theme('th2',  (primary: $c1, accent: $c2, theme: dark))
@include md-register-theme('th2i', (primary: $c2, accent: $c1, theme: light))
$c1: $color-dark1
$c2: $color-light3
@include md-register-theme('th3',  (primary: $c1, accent: $c2, theme: dark))
@include md-register-theme('th3i', (primary: $c2, accent: $c1, theme: light))
$c1: $color-dark3
$c2: $color-light1
@include md-register-theme('th4',  (primary: $c1, accent: $c2, theme: dark))
@include md-register-theme('th4i', (primary: $c2, accent: $c1, theme: light))
$c1: $color-dark2
$c2: $color-light1
@include md-register-theme('th5',  (primary: $c1, accent: $c2, theme: dark))
@include md-register-theme('th5i', (primary: $c2, accent: $c1, theme: light))
$c1: $color-dark1
$c2: $color-light1
@include md-register-theme('th6',  (primary: $c1, accent: $c2, theme: dark))
@include md-register-theme('th6i', (primary: $c2, accent: $c1, theme: light))
$c1: $color-dark
$c2: $color-light
@include md-register-theme('th7',  (primary: $c1, accent: $c2, theme: dark))
@include md-register-theme('th7i', (primary: $c2, accent: $c1, theme: light))
@import '~vue-material/dist/theme/all'
//@import '~@/node_modules/vue-material/dist/components/MdButton/theme'

</style>



// WEBPACK FOOTER //
// main/Dikobraz.vue